import { createContext, useContext, useEffect } from 'react';
import { type ContainerProps } from '../props';

type ContainerContextProps = Omit<ContainerProps, 'children'>;

const ContainerContext = createContext<{ setValues: (value: ContainerContextProps) => void }>({
  setValues: () => {},
});
export const ContainerContextProvider = ContainerContext.Provider;

export function useContainerContext() {
  return useContext(ContainerContext);
}

export function useSetContainerValues(value: ContainerContextProps) {
  const context = useContainerContext();
  useEffect(() => {
    context.setValues(value);
    return () => {
      context.setValues({});
    };
  }, [context, value]);
}
